import React, { useState } from "react";
import { useCookieAuthState } from "../hooks/useCookieAuthState";
import { generateStateAndNonce } from "../utils/crypto";
import AuthContextProvider from "./AuthContextProvider";
const hasExpired = (expiresIn = 0, timestamp = 0) => {
    return Boolean(expiresIn * 1000 + timestamp < Date.now());
};
/**
 * Authentication context component.
 * Provides the app with session information.
 *
 * @copyright 2021 Noom, Inc.
 * @author nikola
 */
export function AuthContext({ children, clientId, useOneLoginAuth = true, useCSAuth = true, autoCookieName, useAutoCookieAuth = false, csClientId, csServerUrl, csExtras, onLoginError, onLoginSuccess, }) {
    const authState = useCookieAuthState();
    const [inProgress, setInProgress] = useState(false);
    const [error, setError] = useState();
    const csProps = useCSAuth
        ? { useCSAuth, csClientId, csServerUrl, csExtras }
        : { useCSAuth };
    const olProps = useOneLoginAuth
        ? { useOneLoginAuth, clientId }
        : { useOneLoginAuth };
    const aclProps = useAutoCookieAuth
        ? { useAutoCookieAuth, autoCookieName }
        : {
            useAutoCookieAuth,
        };
    /** Check if the oneLogin token is expired  */
    const shouldReLogin = () => {
        if (!authState || !authState.state) {
            return true;
        }
        const { state } = authState;
        if (state.useCSAuth) {
            return hasExpired(state.coachServer.expiresIn, state.timestamp);
        }
        return hasExpired(state.expiresIn, state.timestamp);
    };
    const reset = () => {
        setInProgress(false);
        setError(undefined);
    };
    return (React.createElement(AuthContextProvider, Object.assign({}, olProps, aclProps, csProps, { authState: authState, inProgress: inProgress, setInProgress: setInProgress, error: error, setError: setError, generateStateAndNonce: generateStateAndNonce, shouldReLogin: shouldReLogin, reset: reset, onLoginError: onLoginError, onLoginSuccess: onLoginSuccess }), children));
}
export default AuthContext;
//# sourceMappingURL=AuthContext.js.map